var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import { isInsideIFrame } from './utils/iframe';
import { buildElementLink } from './utils/link';
import { IFrameCommunicator, IFrameMessageType } from './lib/IFrameCommunicator';
import { NodeSmartLinkProvider, NodeSmartLinkProviderEventType } from './lib/NodeSmartLinkProvider';
import { createStorage } from './utils/storage';
import { validateElementClickMessageData } from './utils/validation';
import { isQueryParamPresent } from './utils/query';
var initialState = {
  queryTimerId: 0
};
var defaultConfiguration = {
  languageCodename: null,
  projectId: null,
  queryParam: 'kontent-smart-link-enabled'
};

var Plugin =
/** @class */
function () {
  function Plugin(configuration) {
    var _this = this;

    this.destroy = function () {
      var _a;

      _this.unwatchQueryParams();

      _this.nodeSmartLinkProvider.destroy();

      (_a = _this.iFrameCommunicator) === null || _a === void 0 ? void 0 : _a.destroy();
    };

    this.updateConfiguration = function (configuration) {
      _this.configuration = __assign(__assign({}, _this.configuration), configuration);
    };

    this.updateState = function (state) {
      _this.state = __assign(__assign({}, _this.state), state);
    };

    this.initializeIFrameCommunication = function () {
      if (!isInsideIFrame() || _this.iFrameCommunicator) {
        throw new Error('Cannot initialize iframe communication while not inside the iframe.');
      }

      _this.iFrameCommunicator = new IFrameCommunicator();
      var storage = createStorage('kontent-smart-link:iframe-settings');
      var stored = storage.get();
      var enabled = stored !== null ? stored === null || stored === void 0 ? void 0 : stored.enabled : true;

      if (enabled) {
        _this.nodeSmartLinkProvider.enable();
      }

      _this.iFrameCommunicator.addMessageListener(IFrameMessageType.Status, function (data) {
        if (!data || !_this.nodeSmartLinkProvider) return;

        _this.toggleNodeSmartLinkProvider(data.enabled);

        storage.set({
          enabled: data.enabled
        });
      });

      _this.iFrameCommunicator.sendMessage(IFrameMessageType.Initialized, {
        projectId: _this.configuration.projectId,
        languageCodename: _this.configuration.languageCodename,
        enabled: enabled
      });
    };

    this.watchQueryParams = function () {
      if (isInsideIFrame()) {
        throw new Error('No need to watch query params inside the iframe.');
      }

      if (_this.state.queryTimerId) {
        clearTimeout(_this.state.queryTimerId);
      }

      var isPluginEnabled = isQueryParamPresent(_this.configuration.queryParam);
      var hasChanged = _this.nodeSmartLinkProvider.enabled !== isPluginEnabled;

      if (hasChanged) {
        _this.toggleNodeSmartLinkProvider(isPluginEnabled);
      }

      _this.updateState({
        queryTimerId: setTimeout(_this.watchQueryParams, 1000)
      });
    };

    this.unwatchQueryParams = function () {
      clearTimeout(_this.state.queryTimerId);
    };

    this.listenToHighlighterEvents = function () {
      _this.nodeSmartLinkProvider.addEventListener(NodeSmartLinkProviderEventType.ElementClicked, _this.onElementClick);
    };

    this.onElementClick = function (elementClickData) {
      var data = __assign(__assign({}, elementClickData), {
        projectId: elementClickData.projectId || _this.configuration.projectId || undefined,
        languageCodename: elementClickData.languageCodename || _this.configuration.languageCodename || undefined
      });

      if (validateElementClickMessageData(data)) {
        if (isInsideIFrame() && _this.iFrameCommunicator) {
          _this.iFrameCommunicator.sendMessage(IFrameMessageType.ElementClicked, data);
        } else {
          var link = buildElementLink(data.projectId, data.languageCodename, data.itemId, data.elementCodename);
          window.open(link, '_blank');
        }
      }
    };

    this.toggleNodeSmartLinkProvider = function (force) {
      var shouldEnable = typeof force !== 'undefined' ? force : !_this.nodeSmartLinkProvider.enabled;

      if (shouldEnable) {
        _this.nodeSmartLinkProvider.enable();
      } else {
        _this.nodeSmartLinkProvider.disable();
      }
    };

    this.nodeSmartLinkProvider = new NodeSmartLinkProvider();
    this.state = initialState;
    this.configuration = __assign(__assign({}, defaultConfiguration), configuration);

    if (isInsideIFrame()) {
      this.initializeIFrameCommunication();
    } else {
      this.watchQueryParams();
    }

    this.listenToHighlighterEvents();
  }

  return Plugin;
}();

var PluginWrapper =
/** @class */
function () {
  function PluginWrapper() {
    var _this = this;

    this.plugin = null;

    this.destroy = function () {
      var _a;

      (_a = _this.plugin) === null || _a === void 0 ? void 0 : _a.destroy();
      _this.plugin = null;
    };

    this.setConfiguration = function (configuration) {
      if (!_this.plugin) {
        throw new Error('KontentSmartLink is not initialized or has already been destroyed.');
      } else {
        _this.plugin.updateConfiguration(configuration);
      }
    };
  }

  PluginWrapper.initializeOnLoad = function (configuration) {
    return new Promise(function (resolve) {
      window.addEventListener('load', function () {
        resolve(PluginWrapper.initialize(configuration));
      });
    });
  };

  PluginWrapper.initialize = function (configuration) {
    if (!PluginWrapper.instance) {
      PluginWrapper.instance = new PluginWrapper();
    }

    if (!PluginWrapper.instance.plugin) {
      PluginWrapper.instance.plugin = new Plugin(configuration);
    }

    return PluginWrapper.instance;
  };

  return PluginWrapper;
}();

export default PluginWrapper;